export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-accent-100/60 via-background-50 to-primary-100/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-accent-200/30 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-primary-100/30 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-5">
              每日更新 · 免费追番 · 高清在线
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              樱花动漫
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 mt-2">
                免费动漫全集在线观看平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading mb-6">
              热门完结动漫，随时随地轻松在线追番
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              樱花动漫网汇聚海量免费动漫全集资源，覆盖热血、奇幻、恋爱、搞笑等各类热门完结动漫类型。
              每日更新好看的动漫资源，支持高清在线观看，无论是最新番剧还是经典回顾，都能在这里找到。
              当前站点已收录超过 3000 部动漫作品，涵盖日漫、国漫、剧场版等丰富内容，
              为动漫爱好者打造一站式的免费在线追番体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">3000+</div>
                <div className="text-xs text-foreground-500 mt-1">动漫资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-500">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">持续追番</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-secondary-500">全类型覆盖</div>
                <div className="text-xs text-foreground-500 mt-1">20+ 分类</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始追番
              </a>
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-7 py-3 border border-foreground-300 text-foreground-700 rounded-full text-sm font-medium hover:border-primary-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line text-lg"></i>
                热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20with%20colorful%20anime%20characters%20gathered%20together%2C%20cherry%20blossom%20petals%20drifting%20in%20soft%20breeze%2C%20warm%20golden%20and%20pink%20ambient%20lighting%2C%20dreamy%20atmosphere%2C%20modern%20clean%20anime%20art%20style%2C%20cinematic%20composition%20with%20soft%20depth%20of%20field%2C%20editorial%20quality%2C%20high%20detail%2C%20vibrant%20colors%2C%20youthful%20energy&width=800&height=600&seq=hero-visual-01&orientation=landscape"
                alt="樱花动漫 - 免费动漫全集在线观看"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-background-50/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}